import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Button,
  useColorModeValue,
  Icon,
} from '@chakra-ui/react';
import { Eye, EyeSlash } from '@phosphor-icons/react';

export default function MapLegend({
  showMainSites,
  onToggleMainSites,
  showSublocations,
  onToggleSublocations,
  ...boxProps
}) {
  // Using semantic tokens from theme.js
  const bgColor = useColorModeValue('bg.surface', 'bg.surface');
  const borderColor = useColorModeValue('border.default', 'border.default');
  const titleColor = useColorModeValue('text.default', 'text.default');
  const textColor = useColorModeValue('text.muted', 'text.muted');

  return (
    <Box
      position="absolute"
      bottom={4}
      left={4}
      bg={bgColor}
      borderRadius="md"
      boxShadow="sm"
      border="1px"
      borderColor={borderColor}
      p={3}
      maxW="300px"
      zIndex={5}
      overflow="hidden"
      _before={{
        content: '""',
        position: 'absolute',
        top: 0, 
        left: 0, 
        right: 0, 
        bottom: 0,
        opacity: 0.08,
        pointerEvents: 'none',
        bgImage: useColorModeValue('var(--texture-parchment)', 'var(--texture-leather)'),
        bgRepeat: 'repeat',
        bgSize: '200px',
        bgBlendMode: useColorModeValue('multiply', 'multiply'),
        zIndex: 0,
      }}
      {...boxProps}
    >
      <VStack spacing={3} align="stretch" position="relative" zIndex={1}>
        <Text 
          fontWeight="medium" 
          fontSize="sm" 
          color={titleColor} 
          fontFamily="heading"
          textTransform="uppercase"
          letterSpacing="wider"
          borderBottom="1px solid"
          borderColor="border.light"
          pb={1}
        >
          Map Legend
        </Text>

        <HStack justify="space-between" spacing={3}>
          <HStack spacing={2}>
            <Box as="span" position="relative" width="20px" height="20px" display="flex" alignItems="center" justifyContent="center">
              <Box as="img" src="/marker-main.svg" w="20px" h="20px" position="relative" />
            </Box>
            <Text fontSize="sm" color={textColor} fontFamily="body">Main Sites</Text>
          </HStack>
          <Button
            onClick={onToggleMainSites}
            size="xs"
            variant="journal"
            leftIcon={<Icon as={showMainSites ? Eye : EyeSlash} weight="light" />} 
            iconSpacing={1}
            px={2}
          >
            {showMainSites ? 'Visible' : 'Hidden'}
          </Button>
        </HStack>
        
        <HStack justify="space-between" spacing={3}>
          <HStack spacing={2}>
            <Box as="span" position="relative" width="20px" height="20px" display="flex" alignItems="center" justifyContent="center">
              <Box as="img" src="/marker-sub.svg" w="20px" h="20px" position="relative" />
            </Box>
            <Text fontSize="sm" color={textColor} fontFamily="body">Sublocations</Text>
          </HStack>
          <Button
            onClick={onToggleSublocations}
            size="xs"
            variant="journal"
            leftIcon={<Icon as={showSublocations ? Eye : EyeSlash} weight="light" />}
            iconSpacing={1}
            px={2}
          >
            {showSublocations ? 'Visible' : 'Hidden'}
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
}
